import { Modal } from 'stories/components'
import { formatTime } from 'utils'

import { ExpirationDatesItem } from './types'

export const HistoryModal = ({ data, onClose }: { data: ExpirationDatesItem; onClose: Function }) => {
  return (
    <Modal
      title={`History - ${data?.title}`}
      titleOkay=""
      onClose={() => onClose()}
      onOk={() => {}}
      isOpen
      lastUpdatedAt={Date.now()}
    >
      <div className="overflow-auto shadow-md sm:rounded-lg">
        <table className="w-full text-sm text-left text-gray-900 dark:text-gray-400 pl-6">
          <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="px-6 py-3">
                No
              </th>
              <th scope="col" className="px-6 py-3">
                Type
              </th>
              <th scope="col" className="px-6 py-3">
                Value
              </th>
              <th scope="col" className="px-6 py-3">
                By
              </th>
              <th scope="col" className="px-6 py-3">
                Date
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.history?.map((item, index: number) => {
              return (
                <tr key={index} className={`${index % 2 ? 'bg-gray-50' : ''}`}>
                  <td className="px-6 py-3">{index + 1}</td>
                  <td className="px-6 py-3">{item.type}</td>
                  <td className="px-6 py-3">{String(item.value)}</td>
                  <td className="px-6 py-3">{item.by}</td>
                  <td className="px-6 py-3">{formatTime(item.date)}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </Modal>
  )
}
